module.exports = __webpack_public_path__ + "static/media/logo.f41db25e.png";